<div class="-skeleton-list">
  @for (bar of [1, 2, 3, 4, 5, 6]; track bar) {
  <div class="-skeleton">
    <wp-skeleton class="-skeleton-bar -first-line" [loading]="true"></wp-skeleton>
    <wp-skeleton class="-skeleton-bar -second-line" [loading]="true"></wp-skeleton>
    <wp-skeleton class="-skeleton-bar -third-line" [loading]="true"></wp-skeleton>
  </div>
  }
</div>
